import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async relConferirPreenchimento({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(
          `/relatorios/conferir-preenchimento?${params}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relTrimestral({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/relatorios/trimestral?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relTrimestralPorRegional({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(
          `/relatorios/trimestral-por-regional?${params}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relReceitas({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/relatorios/receitas?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relEventos({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/relatorios/eventos?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relExportacao({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/relatorios/exportacao?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relOrcamentario({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/relatorios/orcamentario?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relOrcamentarioTrimestral({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(
          `/relatorios/orcamentario-trimestral?${params}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relOrcamentarioComparativo({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(
          `/relatorios/orcamentario-comparativo?${params}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relOrcamentarioComparativoAno({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(
          `/relatorios/orcamentario-comparativo-ano?${params}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relMemoriaCalculo({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/relatorios/memoria-calculo?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relOrcamentoTempoReal({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(
          `/relatorios/orcamento-tempo-real?${params}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relTotaisCentroCusto({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(
          `/relatorios/totais-centro-custo?${params}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relImportacaoSistego({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(
          `/relatorios/importacao-sistego?${params}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relAnaliseOrcamentaria({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(
          `/relatorios/analise-orcamentaria?${params}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
